import 'select2'; 
//import select2 from 'select2/dist/js/select2'
import 'select2/dist/css/select2.css';



export default class Select {
    Select() {
      $('select').each(function( index ) {

        $(this).select2({
            //minimumResultsForSearch: -1,
            minimumResultsForSearch: -1,
			width: '100%',
            placeholder: function(){
                $(this).data('placeholder')
            },
            //allowClear: true
        });
      });



    }

  
    init() {
      document.querySelector('select') ? this.Select() : null;
    }
  }
  
    